__turbopack_context__.v({
  "arrowLink": "ArrowLink-module__UBixAW__arrowLink",
  "bottom": "ArrowLink-module__UBixAW__bottom",
  "fullwidth": "ArrowLink-module__UBixAW__fullwidth",
  "top": "ArrowLink-module__UBixAW__top",
});
